<template>
    <v-container fluid>
        <v-card class="mb-5 pa-2">
            <card-header
                :title="
                    $t('planPackageModules.form.texts.title', {
                        'title-prefix': $t('form.add-prefix'),
                    })
                "
            />

            <v-row class="pl-6" v-if="planPackage">
                <v-col>
                    <package-details :plan-package="planPackage" />
                </v-col>
            </v-row>

            <v-card-text>
                <v-row class="mb-4">
                    <v-col class="d-flex justify-end">
                        <v-btn
                            small
                            color="success"
                            outlined
                            @click="addModule"
                        >
                            <v-icon left>mdi-plus-circle-outline</v-icon>
                            <span class="hidden-sm-and-down"
                                >Adicionar módulo</span
                            >
                        </v-btn>
                    </v-col>
                </v-row>

                <div
                    v-for="(module, index) in modules"
                    :key="index"
                    class="mb-6"
                >
                    <form-batch
                        :value="module"
                        :index="index"
                        @input="v => (modules[index] = v)"
                        @remove="removeModule(index)"
                        @change-module="changeModule"
                    />
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn :disabled="saving" @click="cancel" text>
                    {{ $t('form.actions.back') }}
                </v-btn>
                <v-btn
                    color="primary"
                    :loading="saving"
                    :disabled="saving"
                    @click="submit"
                >
                    {{ $t('form.actions.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import CardHeader from '@/components/utils/CardHeader'
import PlanPackage from '@/models/plans/PlanPackage'
import PlanPackageModule from '@/models/plans/PlanPackageModule'
import Module from '@/models/plans/Module'
import FormBatch from './FormBatch'
import PackageDetails from '@/views/planPackages/PackageDetails'

export default {
    props: ['id'],
    components: {
        CardHeader,
        FormBatch,
        PackageDetails,
    },
    data: () => ({
        modules: [],
        moduleModel: new Module(),
        saving: false,
        planPackage: null,
    }),

    created() {
        this.init()
    },

    methods: {
        async init() {
            const planPackage = new PlanPackage()
            this.planPackage = await planPackage.find(this.id)
            this.addModule()
        },
        addModule() {
            this.modules.push(new PlanPackageModule(this.id))
        },
        removeModule(index) {
            this.modules.splice(index, 1)
        },
        changeModule(index, module) {
            console.log('changeModule')
            this.modules[index] = module
        },
        cancel() {
            this.$router.push({
                name: 'planPackageModules.index',
                params: { id: this.id },
            })
        },
        serialize(item) {
            const m = new PlanPackageModule(this.id)

            m.module_id = item.module_id
            m.order = item.order
            m.price = item.price
            m.price_type = item.price_type
            m.add_on = item.add_on
            m.amount = item.add_on ? 0 : item.amount || 1
            m.max_amount = item.max_amount

            return m
        },
        async submit() {
            this.saving = true
            try {
                const payload = {
                    modules: this.modules.map(i => this.serialize(i).data()),
                }

                const temp = new PlanPackageModule(this.id)
                await temp.makePersistRequest({
                    url: `${temp.resourceUrl()}batch`,
                    method: 'POST',
                    data: payload,
                })

                this.$bus.$emit(
                    'notify',
                    'success',
                    this.$t('planPackageModules.form.feedback.success'),
                )
                this.$router.push({
                    name: 'planPackageModules.index',
                    params: { id: this.id },
                })
            } catch (e) {
                // no-op: backend validation feedback handled globally if any
            } finally {
                this.saving = false
            }
        },
    },
}
</script>

<style></style>
